import Hero from '..';
import BackgroundImage from '../../BackgroundImage';

const HeroFull = ({ children, image }) => {
  return (
    <Hero data-qa-tag="hero-component">
      <BackgroundImage image={image} data-qa-tag="hero-bg-image">
        {children}
      </BackgroundImage>
    </Hero>
  );
};

export default HeroFull;
